import React from 'react';
import { IconProps } from '.';

const SvgColoredPerson = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#606567'
        d='M2.687 19.34a7.025 7.025 0 0 1 6.97-6.14h4.687a7.025 7.025 0 0 1 6.97 6.14 2.007 2.007 0 0 1-1.992 2.26H4.678a2.007 2.007 0 0 1-1.99-2.26ZM16.8 7.2a4.8 4.8 0 1 1-9.6 0 4.8 4.8 0 0 1 9.6 0Z'
      />
    </svg>
  );
};

export default SvgColoredPerson;
